import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Modal from 'react-responsive-modal';
import { MODAL_HIDE, MENU_TOGGLE, MODAL_ORACLE_COLLECT_EMAILS, MODAL_USER_SET_ETH_ADDRESS, MODAL_USER_PROMPT_LOGIN, MODAL_EVENT_BET_POSTED, NAV_BACK } from '../../constants/action-types';
import authNoMetaMask from '../templates/modals/auth-no-metamask'
import UserPromptLogin from '../templates/modals/user-prompt-login'
import OracleCollectEmails from '../templates/modals/oracle-collect-emails'
import authMetaMaskNoAccount from '../templates/modals/auth-metamask-no-account'
import authNetworkWarning from '../templates/modals/auth-network-warning'
import NoEthAddress from '../templates/snackbars/no-eth-address'
import EventBetPosted from '../templates/modals/event-bet-posted'
import UserSetEthAddress from '../templates/modals/user-set-eth-address'
import WorkInProgress from '../templates/snackbars/work-in-progress'

class RootComponent extends Component {
    constructor(props) {

        super(props);

    }

    modals = {
        MODAL_ORACLE_COLLECT_EMAILS: OracleCollectEmails,
        MODAL_USER_SET_ETH_ADDRESS: UserSetEthAddress,
        MODAL_USER_PROMPT_LOGIN: UserPromptLogin,
        MODAL_EVENT_BET_POSTED: EventBetPosted,
    }

    snackbars = {
        SNACKBAR_NO_ETH_ADDRESS: NoEthAddress
    }

    getModalBody() {

        const TagName = this.modals[this.props.modal.modal];
        
        if (!TagName) return console.log('No modal')

        return (<TagName />)

    }

    getSnackbar() {

        // const TagName = this.snackbars[this.props.app.snackbar];
        
        // if (!TagName) return false

        return (<div><NoEthAddress /></div>)

    }

    componentDidMount() {

    }
    render() {

        return (
            <div id='content-section-outer'> 
                {/* {this.props.app.showSnackbar ?  */}
                    {this.getSnackbar() }
                {/* : (null)} */}
                <div id='content-mobile-nav'>
                    <div id='content-mobile-nav-menu-trigger' onClick={this.props.toggleMenu.bind(this)}>
                        <span className="icon-menu5"></span>
                    </div>
                </div>
                {this.props.children}
                <Modal
                    className='modal'
                    open={this.props.modal.open}
                    onClose={this.props.closeModal}
                    center>
                    {this.getModalBody()}
                </Modal>
            </div>
        );

    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    navBack: () => dispatch({ type: NAV_BACK }),
    toggleMenu: () => dispatch({ type: MENU_TOGGLE }),
    closeModal: () => dispatch({ type: MODAL_HIDE })

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RootComponent)


// WEBPACK FOOTER //
// ./src/components/general/Root.js